import React, {useState, useEffect} from 'react';
import {useTranslation} from 'react-i18next';

import Uploader from 'services/Uploader';
import Urls from 'configs/urls';

function Upload(props) {
	const {t} = useTranslation();
	const [selectedFiles, setSelectedFiles] = useState(undefined);
	const [currentFile, setCurrentFile] = useState(undefined);
	const [progress, setProgress] = useState(0);
	const [message, setMessage] = useState('');

	let {
		label = '',
		name = '',
		required = false,
		multiple = false,
		updateItem = () => {
		},
		item = {},
		isError = false,
		onValide = false
	} = props;


	let initialValue = multiple ? [] : '';
	let value = typeof item[name] !== 'undefined' ? item[name] : initialValue;

	let paramsInput = {}
	if ((isError || onValide) && required) {
		paramsInput = {
			required: true
		};
	}

	const selectFile = (event) => {
		setSelectedFiles(event.target.files);
	}

	const nextUpload = (index) => {
		let files = Array.from(selectedFiles);
		let max = files.length;
		if (index < max) {
			let file = files[index];
			setProgress(0);
			setCurrentFile(file);

			Uploader.upload(
				file,
				(error, response) => {
					if (error) {
						return setMessage(t('Form.errorUpload'));
					}

					if (typeof (response['@id']) !== 'undefined') {
						let newValue = response;
						if (multiple) {
							newValue = value;
							value.push(response);
						}
						updateItem(name, newValue);
					}
					nextUpload(index + 1);
				},
				(event) => {
					setProgress(Math.round((100 * event.loaded) / event.total));
				}
			);
		} else {
			setCurrentFile(undefined);
			setSelectedFiles([]);
			setProgress(0);
		}
	}
	useEffect(() => {
		if (typeof selectedFiles == "undefined") {
			return;
		}
		if (selectedFiles.length === 0) {
			return;
		}
		nextUpload(0);

	}, [selectedFiles]);


	const renderFile = (file, index = 0) => {
		if (file === null || typeof file === 'undefined') {
			return (null);
		}

		let filePath = file;
		if (typeof file.filePath !== 'undefined') {
			filePath = file.filePath;
		}
		if (filePath === null || filePath === '' || typeof filePath.toLowerCase !== 'function') {
			return (null);
		}

		let isImage = filePath.toLowerCase().match(/\.(jpeg|jpg|gif|png)$/) != null;
		return (
			<div className="dz-preview dz-file-preview mb-3 dz-complete">
				<div className="d-flex flex-row">
					<div className="p-0 position-relative image-container">
						<div className="preview-container">
							{isImage && (
								<img
									src={Urls.mediaResized + filePath}
									className="img-thumbnail border-0"
								/>
							)}
							{!isImage && (
								<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2"
								     fill="none" strokeLinecap="round" strokeLinejoin="round"
								     className="cs-file-text preview-icon">
									<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
									<polyline points="14 2 14 8 20 8"></polyline>
									<line x1="16" y1="13" x2="8" y2="13"></line>
									<line x1="16" y1="17" x2="8" y2="17"></line>
									<polyline points="10 9 9 9 8 9"></polyline>
								</svg>
							)}
						</div>
					</div>
					<div className="ps-3 pt-2 pe-2 pb-1 dz-details position-relative">
						<div><span data-dz-name="">{file.name}</span></div>
						<div className="text-primary text-extra-small" data-dz-size="">
							<strong>{file.sizeFile}</strong> {file.sizeFileUnit}</div>
					</div>
					{/*<a href="#/" className="remove" data-dz-remove=""><i className="cs-bin"></i></a>*/}
				</div>
			</div>
		);
	}

	return (
		<div className={'Upload mb-3' + (((isError || onValide) && required) ? ' was-validated' : '')}>
			<label className="form-label">
				{label} {required && (<span>*</span>)}
			</label>
			{message && (
				<div className="alert alert-light" role="alert">
					{message}
				</div>
			)}
			{currentFile && (
				<div className="progress">
					<div
						className="progress-bar progress-bar-info progress-bar-striped"
						role="progressbar"
						aria-valuenow={progress}
						aria-valuemin="0"
						aria-valuemax="100"
						style={{width: progress + "%"}}
					>
						{progress}%
					</div>
				</div>
			)}
			<label htmlFor={'file' + name} className="dropzone dz-clickable">
				<span>
					{t('Form.chooseFile')}
				</span>
				<input
					type="file"
					multiple={multiple}
					id={'file' + name}
					onChange={selectFile}
					{...paramsInput}
				/>
			</label>
			<div className="invalid-feedback">{t('Form.required')}</div>
			{multiple && (
				<div>
					{value.map((file, index) => {
						return renderFile(file, index);
					})}
				</div>
			)
			}
			{multiple === false && typeof (value) !== 'undefined' && (
				<div>
					{renderFile(value)}
				</div>
			)}
		</div>
	);
}

export default Upload;
